import React from 'react';
import ReactDOM from 'react-dom';
import { CookiesProvider } from 'react-cookie';
import { HashRouter } from 'react-router-dom';
import App from './App';
import { SelectedDataProvider } from './context/selectedData';
import { FeaturedReportProvider } from './context/featuredReport';
import { ResponsiveProvider } from './context/responsiveContext';

ReactDOM.render(
  <React.StrictMode>
    <ResponsiveProvider>
      <FeaturedReportProvider>
        <SelectedDataProvider>
          <HashRouter basename="/">
            <CookiesProvider>
              <App />
            </CookiesProvider>
          </HashRouter>
        </SelectedDataProvider>
      </FeaturedReportProvider>
    </ResponsiveProvider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
